import { api } from '../../../shared/services/api/client';

/**
 * Get available subscription plans
 */
export const getPlans = () => {
    return api.get('/billing/plans');
};

/**
 * Get current subscription status
 */
export const getSubscription = () => {
    return api.get('/billing/subscription');
};

/**
 * Create checkout session for subscription
 * @param {string} priceId - Stripe price ID
 */
export const createCheckoutSession = (priceId) => {
    return api.post('/billing/checkout', { priceId });
};

/**
 * Create customer portal session
 */
export const createPortalSession = () => {
    return api.post('/billing/portal');
};

/**
 * Set plan to free tier when there is no active Stripe subscription (e.g. admin-assigned tier).
 */
export const downgradeToFree = () => {
    return api.post('/billing/downgrade-to-free');
};

/**
 * Get invoice history
 */
export const getInvoices = () => {
    return api.get('/billing/invoices');
};


